// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"718f5afc","990":"ac96e9a9"}[chunkId] + ".chunk.js";
};